import addDays from 'date-fns/addDays'

type SameSite = 'Strict' | 'Lax' | 'None'

export function setCookie(properties: {
  name: string
  value: string
  expireInDays?: number
  sameSite?: SameSite
  domain?: string
}): void {
  const { name, value, expireInDays, sameSite = 'Strict', domain = location.host } = properties
  const secure = window.location.protocol === 'https:' ? ' Secure;' : ''
  let cookieString = `${name}=${value}; path=/; domain=${domain}; SameSite=${sameSite};${secure}`

  if (expireInDays) {
    const date = addDays(new Date(), expireInDays)
    cookieString += ` expires=${date.toUTCString()};`
  } else if (expireInDays === 0) {
    cookieString += ` expires=0;`
  }

  document.cookie = cookieString
}

export function getCookie(name: string): string | undefined {
  const cookies = document.cookie.split('; ')
  const cookie = cookies.find((row) => row?.trim()?.startsWith(name))

  return cookie?.slice(name.length + 1)
}

export function deleteCookie(name: string, domain?: string): void {
  const removalExpireDate = new Date(0).toUTCString()
  document.cookie = `${name}=; expires=${removalExpireDate}; path=/; domain=${domain || location.host};`
}

export function getMetaCookies(): { fbp?: string; fbc?: string } {
  const fbp = getCookie('_fbp')
  const fbc = getCookie('_fbc')

  return { fbp, fbc }
}
